import { In } from 'typeorm'

import { Domain, getDataSource } from '@things-factory/shell'
import { Activity, ActivityInstance, issue } from '@things-factory/worklist'

import { DataSet } from '../service/data-set/data-set.js'

export async function issueDataCollectionTask(
  domainId: string,
  dataSetId: string,
  context: ResolverContext
): Promise<ActivityInstance | void> {
  return await getDataSource().transaction(async tx => {
    const domain = await tx.getRepository(Domain).findOneBy({ id: domainId })

    if (!domain) {
      throw new Error(`domain(${domainId}) not found`)
    }

    var dataSets = await tx.getRepository(DataSet).find({
      where: {
        domain: {
          id: In([domain.id, domain.parentId].filter(Boolean))
        },
        id: dataSetId
      },
      relations: ['entryRole']
    })

    const dataSet = dataSets.find(ds => ds.domainId === domain.id) || dataSets.find(ds => ds.domainId === domain.parentId)

    var activities = await tx.getRepository(Activity).find({
      where: {
        domain: { id: In([domain.id, domain.parentId].filter(Boolean)) },
        name: 'Collect Data'
      }
    })

    const activity = activities.find(a => a.domainId === domain.id) || activities.find(a => a.domainId === domain.parentId)

    if (activity) {
      const { entryRole, timeLimit } = dataSet

      /* 해당 dataset에 대한 데이타 수집 태스크를 dataset entryRole에게 할당한다. */
      if (entryRole) {
        const activityInstance = {
          name: `[Data 수집] ${dataSet.name}`,
          description: dataSet.description,
          activityId: activity.id,
          dueAt: new Date(Date.now() + (timeLimit || activity.standardTime || 24 * 60 * 60) * 1000),
          input: {
            dataSetId: dataSet.id,
            dataSetName: dataSet.name
          },
          assigneeRole: entryRole,
          threadsMin: 1,
          threadsMax: 1
        }

        context.state = {
          ...context.state,
          domain,
          tx
        }

        return await issue(activityInstance, context)
      } else {
        throw new Error(
          `Data Entry Role not set. So Data Collect Activity for ${dataSet.name}($dataSet.id) could not be issued.`
        )
      }
    } else {
      throw new Error(`Data Collect Activity is not installed.`)
    }
  })
}
